import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAll } from 'services/warehouses.service';
import { STATUSES } from 'redux/statuses';

export const setWarehousesIfEmpty = createAsyncThunk(
  'warehouses/setWarehousesIfEmpty',
  async (payload, { getState }) => {
    try {
      const { data } = await getAll();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  {
    condition(payload, { getState }) {
      const { warehouses } = getState();
      return warehouses.status === STATUSES.EMPTY;
    },
  },
);

const initialState = {
  status: STATUSES.EMPTY,
  items: [],
};

const warehousesSlice = createSlice({
  name: 'warehouses',
  initialState,
  reducers: {
    setWarehouses(state, action) {
      return {
        status: STATUSES.FULFILLED,
        items: action.payload,
      };
    },
    unsetWarehouses(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setWarehousesIfEmpty.pending, (state, action) => {
        state.status = STATUSES.PENDING;
      })
      .addCase(setWarehousesIfEmpty.fulfilled, (state, action) => {
        return {
          status: STATUSES.FULFILLED,
          items: action.payload,
        };
      });
  },
});

export const { setWarehouses, unsetWarehouses } = warehousesSlice.actions;

export default warehousesSlice.reducer;
